import UploadDialog from '@components/uploader/UploadDialog.jsx';
import {MODALS} from '@src/constants';
import {useStore} from '@src/stores/useStore.ts';
import lazyRetry from '@src/utils/lazyRetry.ts';
import React, {Suspense} from 'react';

const ApiDialog = lazyRetry(() => import('./api-dialog/ApiDialog.jsx'));
const SaveSearchDialog = lazyRetry(() => import('./SaveSearchDialog.jsx'));
const ShareDialog = lazyRetry(() => import('./share.jsx'));
const OrdersDialog = lazyRetry(
  () => import('./orders-dialog/ConnectedOrdersDialog.jsx'),
);

const ModalsManager = () => {
  const activeModal = useStore(state => state.modals.activeModal);
  const hideModal = useStore(state => state.modals.hideModal);

  let activeModalComponent;

  switch (activeModal) {
    case MODALS.SAVE_SEARCH:
      activeModalComponent = <SaveSearchDialog onClose={hideModal} />;
      break;
    case MODALS.API:
      activeModalComponent = <ApiDialog onClose={hideModal} />;
      break;
    case MODALS.ORDER:
      activeModalComponent = <OrdersDialog onClose={hideModal} />;
      break;
    case MODALS.SHARE:
      activeModalComponent = <ShareDialog onClose={hideModal} />;
      break;
    case MODALS.UPLOAD:
      activeModalComponent = <UploadDialog onClose={hideModal} />;
      break;
    default:
      activeModalComponent = null;
  }

  return <Suspense>{activeModalComponent}</Suspense>;
};

export default ModalsManager;
